export default (obj) => {
    if(obj!=undefined && obj!=null){
    const form = new FormData()
    
    for (const [key, value] of Object.entries(obj)) {
        if (value==null||value==undefined) {
            
        }
        else if(typeof(value) == "object" && value.type && value.size){
            form.append(key, value)
        }
        else if(typeof(value) == "object" && value[0]?.type && value[0]?.size){
            value.map((item, index) => {
                form.append(key, item)
            })
        }
        else if(typeof(value) == "object"){
            form.append(key, JSON.stringify(value))
        }
        else if (Array.isArray(value)) {
            // Check if it's an array
            value.forEach((item, index) => {
                if (item && typeof item === "object" && item.type && item.size) {
                    form.append(`${key}[${index}]`, item);
                } else if (item && typeof item === "string") {
                    // Handle array of strings
                    form.append(`${key}[${index}]`, item);
                } else {
                    form.append(`${key}[${index}]`, JSON.stringify(item));
                }
            });
        }
        else {
            form.append(key, value)
        }   
    }

    return form
}else{
    return null;
}
  }